export default function () {
  const widgetName = 'cardWidgetOne';
  const widgetOpts = cardWidgetOneOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function (data, owl, hasData) {

      $(`#${widgetName} .card-widget-item`).each(function () {

        $(this).find('.buttonwrap').remove();

        $(this).attr({
          "data-aos": "fade-left",
          "data-aos-easing": "linear",
          "data-aos-duration": "300",
          "data-aos-delay": "200",
          "data-aos-once": "true",

        })
      })

    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false
  });

}